import React from "react";
import { useTable } from "../../Components/useTable";

const DeactivateUser = () => {
  const type = "Deleted Users";
  const limitPerpage = 100;
  const pageRowslinit = [100, 200, 500, 1000];
  const headCells = [
    { id: "name", numeric: false, label: "Name" },
    { id: "code", numeric: false, label: "RID" },
    { id: "email", numeric: false, label: "Email" },
    { id: "phone", numeric: false, label: "Phone No" },
    // { id: "createdAt", numeric: false, label: "Created at" },
    { id: "deleted", numeric: false, label: "Deleted at" },
    { id: "action", numeric: false, label: "Action" },
  ];

  const { tableUI } = useTable({
    headCells,
    type,
    limitPerpage,
    pageRowslinit,
  });
  return (
    <div className="admin-body">
      <div className="table-area">{tableUI}</div>
    </div>
  );
};

export default DeactivateUser;
